import { baseQueryHooksFactory } from '../../factories';
import type { IBaseModel } from '../../types/models/baseModel';
import type {
	IChangeRequest,
	INotification,
	INotificationSettings,
} from '../../types/models/notification';
import {
	notificationChangeRequestQueryKeyFactory,
	notificationQueryKeyFactory,
	notificationSettingsQueryKeyFactory,
} from './constants';
import { useDeleteAllNotifications } from './useDeleteAllNotifications';
import { useUnreadNotificationCount } from './useUnreadNotificationCount';

const {
	useNotification,
	useNotificationInfiniteList,
	useNotificationList,
	useDeleteNotification,
} = baseQueryHooksFactory<INotification, 'notification'>(
	'notification',
	notificationQueryKeyFactory
);

export {
	useDeleteAllNotifications,
	useDeleteNotification,
	useNotification,
	useNotificationInfiniteList,
	useNotificationList,
	useUnreadNotificationCount,
};

const {
	fetchNotificationSettingsList,
	useUpdateNotificationSettings,
	useNotificationSettingsList,
} = baseQueryHooksFactory<
	INotificationSettings & IBaseModel,
	'notificationSettings'
>('notificationSettings', notificationSettingsQueryKeyFactory);

export {
	fetchNotificationSettingsList,
	useNotificationSettingsList,
	useUpdateNotificationSettings,
};

const { createChangeRequest } = baseQueryHooksFactory<
	IChangeRequest,
	'changeRequest'
>('changeRequest', notificationChangeRequestQueryKeyFactory);

export { createChangeRequest };
